<div class="mood-calendar-card">
  <div class="mood-calendar-header">
    <div class="mood-calendar-stats">
      <div class="mood-count">{{ loggedCount }}/{{ daysInMonth }}</div>
      <div class="mood-count-label">{{ journalsLabel }}</div>
    </div>

    <button
      type="button"
      class="mood-add-btn"
      [class.mood-add-btn--logged]="showMoodLogged"
      (click)="openRegisterMoodModal()"
      [disabled]="showMoodLogged"
      [attr.aria-label]="showMoodLogged ? ('moodLoggedTodayText' | translate:translations) : ('addYourMoodText' | translate:translations)">
      @if (!showMoodLogged) {
        <img src="assets/circle-plus.svg" alt="">
      }
      @if (showMoodLogged) {
        <img src="assets/circle-tick.svg" alt="">
      }
    </button>
  </div>

  <div class="mood-calendar-grid" role="grid" [attr.aria-label]="journalsLabel">
    @for (label of weekdayLabels; track label) {
      <div class="mood-weekday" role="columnheader">{{ label }}</div>
    }

    @for (cell of calendarDays; track cell) {
      @if (cell.isPadding) {
        <div class="mood-calendar-cell mood-calendar-cell--padding" role="gridcell"></div>
      }
      @if (!cell.isPadding) {
        <button
          type="button"
          class="mood-calendar-cell"
          role="gridcell"
          [class.mood-skipped]="cell.status === 'skipped'"
          [class.mood-logged]="cell.status === 'logged'"
          [class.mood-future]="cell.status === 'future'"
          [class.mood-today]="cell.isToday"
          [ngStyle]="getDayStyle(cell)"
          [disabled]="cell.status === 'future'"
          (click)="onDayClick(cell)"
          [attr.aria-label]="cell.day + (cell.mood ? ', mood ' + cell.mood.moodId : '')">
        </button>
      }
    }
  </div>

  <div class="mood-calendar-legend">
    <div class="legend-item">
      <span class="legend-swatch legend-swatch--skipped"></span>
      <span>{{ 'moodSkippedText' | translate:translations }}</span>
    </div>
    @if (getMoodScaleItem(1); as mood1) {
      <div class="legend-item">
        <span class="legend-swatch" [style.background-color]="mood1.description"></span>
        <span><strong>1</strong>: {{ 'extremelyPoorText' | translate:translations }}</span>
      </div>
    }
    @if (getMoodScaleItem(5); as mood5) {
      <div class="legend-item">
        <span class="legend-swatch" [style.background-color]="mood5.description"></span>
        <span><strong>5</strong>: {{ 'neutralText' | translate:translations }}</span>
      </div>
    }
    @if (getMoodScaleItem(10); as mood10) {
      <div class="legend-item">
        <span class="legend-swatch" [style.background-color]="mood10.description"></span>
        <span><strong>10</strong>: {{ 'extremelyGoodText' | translate:translations }}</span>
      </div>
    }
  </div>
</div>
